import { Component, OnInit } from '@angular/core';
import { config } from '../../../config.prod';

@Component({
  selector: 'ngx-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  // config = config;
  constructor() { }

  ngOnInit() {
  }

}
